export default function TermsAndConditions() {
  return (
    <main className="terms-style px-10 md:px-20 lg:px-[15rem] xl:px-[25rem] py-10 dark:text-white">
      <h1 className="w-full flex justify-center text-lg mb-5">
        <b>NEWT: AIKA - TERMS OF SERVICE </b>
      </h1>
      <span>Effective Date: February 15, 2022</span>
      <ol>
        <li>
          <h2>
            <b>1.</b>
            <u>
              <b>Welcome to Newt: Aika!</b>
            </u>
          </h2>
          <p>
            Newt: Aika is an online service brought to you by Avara UI Labs Ltd. (“Avara UI Labs”)
            and its affiliates (collectively, “we,” “us,” or “our”) that allows users to interact
            with each other to tokenize their time in the form of non-fungible time tokens (“Time
            NFTs”), and to offer those Time NFTs for sale in this Site (as defined below). Newt:
            Aika enables users to mint, sell and purchase Time NFTs representing a service or
            activity a user offers.
          </p>
          <p>
            ARBITRATION NOTICE: THESE TERMS (“TERMS”) CONTAIN AN ARBITRATION CLAUSE BELOW. EXCEPT
            FOR CERTAIN TYPES OF DISPUTES MENTIONED IN THAT ARBITRATION CLAUSE, YOU AND WE AGREE
            THAT ANY DISPUTES RELATING TO THE SERVICES (AS DEFINED BELOW) WILL BE RESOLVED BY
            MANDATORY BINDING ARBITRATION, AND YOU WAIVE ANY RIGHT TO A TRIAL BY JURY OR TO
            PARTICIPATE IN A CLASS-ACTION LAWSUIT OR CLASS-WIDE ARBITRATION.
          </p>
          <h3>
            <b>You are entering into a binding Agreement.</b>
          </h3>
          <p>Please carefully review these Terms.</p>
          <p>
            BY ACCESSING OR USING OUR SERVICES, WHICH INCLUDE OUR VARIOUS WEBSITES, INCLUDING,
            WITHOUT LIMITATION, AIKA.GG (THE “SITE”), APPLICATIONS, SMART CONTRACTS, AND OTHER
            SERVICES THAT LINK TO THESE TERMS, AS WELL AS ANY INFORMATION, TEXT, LINKS, GRAPHICS,
            PHOTOS, AUDIO, VIDEO, OR OTHER MATERIALS STORED, RETRIEVED OR APPEARING THEREON, WHETHER
            ACCESSED THROUGH THE SITE OR OTHERWISE (COLLECTIVELY, THE “SERVICES”), YOU ARE ENTERING
            INTO A BINDING AGREEMENT WITH US THAT INCLUDES THESE TERMS, THE NEWT: AIKA - PRIVACY
            POLICY (FOUND HERE), AND OTHER POLICIES REFERENCED HEREIN (COLLECTIVELY, THE
            “AGREEMENT”).
          </p>
          <p>
            To the extent that there is a conflict between these Terms and any applicable additional
            terms, these Terms will control unless expressly stated otherwise. If you don’t agree
            with these Terms, you may not use the Services and should not visit the Site or
            otherwise engage with the Services.
          </p>
          <h3>
            <b>Use of the Services.</b>
          </h3>
          <p>
            To use the Services, you must legally be able to enter into the Agreement. By using the
            Services, you represent and warrant that you meet the eligibility requirement. If you do
            not meet the requirement, you must not access or use the Site or the Services.
          </p>
          <h3>
            <b>We may update the Services and the Terms. </b>
          </h3>
          <p>
            We may update the Services, the Agreement, and any part of the Terms at any time, for
            any reason, in our sole discretion. Once any part of the Agreement is updated and in
            effect, you will be bound by the Terms if you continue to use the Services, including by
            accessing the Site. We may, at any time, and without liability to you, modify or
            discontinue all or part of the Services (including access to the Services via any
            third-party links).
          </p>
          <p>
            You may contact us with questions about your use of the Services at
            wecare@avaralabsui.com. When you communicate with us electronically, you consent to
            receive communications from us electronically. You should review the Terms from time to
            time to ensure that you understand the terms and conditions that apply to you when you
            access or use the Site.
          </p>
        </li>
        <li>
          <h2>
            <b>2.</b>
            <u>
              <b>Services</b>
            </u>
          </h2>
          <h3>
            <b>All transactions and interactions are between or among users. </b>
          </h3>
          <p>
            We make the Services available for users to (a) mint and sell Time NFTs and (b) find and
            purchase Time NFTs. We have no control over whether any Time NFT is offered and/or
            accepted as this is entirely at the discretion of the users.
          </p>
          <p>
            We do not have the ability to – and do not – introduce users to each other or select
            Time NFTs for any user. Through the Site, users may purchase Time NFTs; however, users
            are responsible for evaluating and determining the suitability of any Time NFT on their
            own.
          </p>
          <p>
            If a user decides to purchase a Time NFT, any agreement in relation to the Time NFT is
            formed directly between the users and we are not a party to it. Nothing in this
            Agreement is intended to or should be construed to create a partnership, joint venture,
            franchisor/franchisee or other relationship between us and any user.
          </p>
          <p>
            By minting the Time NFT, the offering user describes the type of service or activity
            they are offering. The offering user determines the terms, conditions, and limitations
            of the Time NFT. The offering user may additionally include fees on secondary sales of
            the Time NFT.
          </p>
          <h3>
            <b>
              We do not vouch for or guarantee the quality or deliverables of any services or
              activity represented by a Time NFT.
            </b>
          </h3>
          <p>
            We do not vouch for or have anything to do with the services or activities underlying
            the Time NFT and thus, do not guarantee that the Time NFTs or the corresponding services
            or activities:
          </p>
          <ul>
            <li>are error free;</li>
            <li>fully address or meet the user’s expectations;</li>
            <li>provide a complete set of deliverables;</li>
            <li>are of a standard consistent with any level of expertise;</li>
            <li>are provided at a fair or reasonable price;</li>
            <li>are achievable in the provided time or at all;</li>
          </ul>
          <h3>
            <b>We do not guarantee the value of Time NFTs.</b>
          </h3>
          <p>
            Time NFTs are sold at a fixed price determined by the offeror and for any secondary sale
            at a price determined solely by the holder of such Time NFT. Subject to market
            conditions, including but not limited to, as supply and demand of various services, the
            value of any Time NFT might be impacted. The blockchain ecosystem in general could be
            negatively impacted by regulatory inquiries, regulatory actions, legislation, or court
            rulings, among other things. A Time NFT’s market value could also decline in light of
            copyright or trademark claims against the use of any deliverable associated with the
            Time NFT.
          </p>
          <p>
            We make no representation or warranty that the price of any Time NFT sold or offered for
            sale on or off of the Site is fair or reasonable. We disclaim any obligation to ensure
            that Time NFTs sold on or through our Services are priced fairly.
          </p>
          <p>
            Use of the Services, including to mint, buy or sell Time NFTs or other digital assets,
            carries material financial risk. Blockchain-based transactions involving cryptocurrency
            and digital assets are, by their nature, highly experimental, risky, volatile, and
            speculative, and the risk of material or total loss is substantial.
          </p>
          <p>
            You acknowledge and agree that you will access and use the Services, including, without
            limitation, the Site, Time NFTs, and their underlying smart contracts, at your own risk.
            You should not use the Services to engage in blockchain-based transactions unless it is
            suitable given your circumstances and financial resources.
          </p>
          <p>
            By using the Services, you represent that you have been, are and will be solely
            responsible for conducting your own due diligence into the risks of a transaction and
            the underlying digital assets.
          </p>
          <h3>
            <b>There may be associated blockchain fees.</b>
          </h3>
          <p>
            All transactions using the Ethereum blockchain require the payment of gas fees, which
            are essentially transaction fees paid on every transaction that occurs on the Ethereum
            network. This includes transactions initiated using the Services. Please note that gas
            fees are non-refundable.
          </p>
          <p>
            <b>
              Users must hold sufficient funds in their linked digital wallet to cover the initiated
              transaction for, including but not limited to, minting a Time NFT, purchasing a Time
              NFT, reselling a Time NFT, as well as any associated gas fees, to complete a
              transaction.
            </b>
          </p>
          <p>
            We do not provide escrow services to users or deliver, hold, and/or receive payment for
            Time NFTs. We do not receive any fees for any Time NFT, the Services, or the Site.
          </p>
          <h3>
            <b>Disputes between users </b>
          </h3>
          <p>
            For disputes arising between or among users relating to a Time NFT, the users shall
            pursue disputes independently between and amongst themselves. You acknowledge and agree
            that we will not and are not obligated to provide any assistance and will not be
            involved in any way. We are not responsible for any services or activities offered
            through the Time NFTs or otherwise on the Site. Users acknowledge that we, for the
            avoidance of doubt, do not have any information regarding any Time NFT, users, users’
            identities, or services beyond what is available or obtainable publicly via the
            blockchain.
          </p>
        </li>
        <li>
          <h2>
            <b>3.</b>
            <u>
              <b>Offerors of Time NFTs</b>
            </u>
          </h2>
          <h3>
            <b>Offerors may use the Services to mint their Time NFTs.</b>
          </h3>
          <p>
            Offerors or offering users, as used in these Terms, are those who mint Time NFTs for
            sale on the Site.
          </p>
          <p>
            By minting a Time NFT, an offeror undertakes to dedicate a certain amount of time for
            rendering a service or activity and guarantees that it has sufficient permissions,
            rights and/or licenses to provide, sell or resell the service or activity offered.
            <b>
              {' '}
              A user will not be able to mint a Time NFT if the digital wallet that they have
              connected to the Site contains insufficient funds to cover the price of minting the
              Time NFT.{' '}
            </b>
          </p>
          <h3>
            <b>Offerors of Time NFTs are independent from us.</b>
          </h3>
          <p>If you offer Time NFTs, you acknowledge, agree, and understand that:</p>
          <ol>
            <li>
              you are not our employee, agent, contractor or associated with us in any way and you
              are not eligible for any of the rights or benefits of employment (including
              unemployment and/or workers compensation insurance) from us;
            </li>
            <li>
              we will not have any liability or obligations, including under or related to any Time
              NFT for any acts or omissions by you or other users;
            </li>
            <li>
              we do not, in any way, supervise, direct, or control the quality or any user or any
              service or activity offered; we do not impose quality standards, nor do we monitor any
              deadline for completion of any services; and do not dictate the performance, methods
              or process you use to perform services underlying any Time NFTs;
            </li>
            <li>
              we do not set or have any control over your pricing, hours, schedules, or location,
              nor are we involved in any other way in determining the nature and amount of any
              compensation that may be charged by or paid to you;
            </li>
            <li>
              you will be paid at such times and amounts as minted to the Time NFT, and we do not,
              in any way, provide or guarantee you any payment;
            </li>
            <li>
              we do not provide you with training or any equipment, labor, tools, or materials
              related to any Time NFT;
            </li>
            <li>
              we do not provide premises or location for you to render any service underlying a time
              NFT; and
            </li>
            <li>
              we do not provide shipping for services related to a Time NFT for any physical work
              product.
            </li>
          </ol>
          <h3>
            <b>Offerors determine the conditions relating to any Time NFT.</b>
          </h3>
          <p>
            By minting a Time NFT, a user is responsible for determining the type of service or
            activity offered as well as the conditions for providing such services or activity
            associated with the Time NFT. Subject to any service, offerors owe a duty to the
            purchaser to devote reasonable efforts, including time, knowledge, skill, attention, and
            care to the provision of the services or activity.
          </p>
          <p>
            If any users enter into any additional written agreements relating to a Time NFT (e.g.,
            confidentiality, invention assignment, assignment of rights, etc.), such agreements
            shall be binding on such users and do not create obligations for us. An additional
            agreement outside the Time NFT might not be binding after a resale of the Time NFT.
          </p>
          <h3>
            <b>Offerors must have all necessary rights and licenses to perform services.</b>
          </h3>
          <p>
            Offerors represent and warrant that they hold all rights, licenses, authorizations, and
            power necessary to perform or grant the rights to any services underlying a Time NFT.
            You agree that any such service or activity will not violate the copyright, trademark,
            right of publicity (e.g., image, likeness, persona, performance, signature, voice or
            other indicia), or other proprietary rights of any third party. Any Time NFT that
            incorporates the works or personas of others must have been created with the necessary
            permission, constitute fair use, or otherwise have a valid legal footing for such use.
          </p>
          <h3>
            <b>Offerors may include a royalty condition for the resale of Time NFTs.</b>
          </h3>
          <p>
            The Newt: Aika smart contracts contain a resale royalty component whereby an offeror can
            include conditions to automatically receive a defined portion of future sales of the
            Time NFT. As the resale royalty is built into the smart contract, once the Time NFT is
            sold, the offeror will automatically receive the preset compensation directly to a
            wallet address indicated by them. The amount of royalty and the wallet address of
            receiving those fees is solely determined by the offeror.
          </p>
        </li>
        <li>
          <h2>
            <b>4.</b>
            <u>
              <b>Purchasers of Time NFTs</b>
            </u>
          </h2>
          <h3>
            <b>Users may use the Services to purchase the Time NFTs. </b>
          </h3>
          <p>
            You should do your own research prior to purchasing a Time NFT. We do not check or make
            representations or guarantees regarding any Time NFT or any user. If you decide to
            purchase a Time NFT, the agreement is directly between the offeror and you, and we are
            not a party to that agreement.
          </p>
          <p>
            By minting a Time NFT, a user agrees to dedicate a certain time period for rendering the
            service to you. You agree to pay the offeror based on the time spent, and not on the
            real or perceived quality of any deliverables provided. For example, if an offeror
            agrees to offer a 1-hour Time NFT to sketch a portrait of you, you accept that the
            quality of the work is subject to the offeror’s abilities and any conditions of the Time
            NFT. You should always evaluate first if the time subject to the Time NFT will be
            sufficient to deliver the results you desire, taking into account the level of
            expertise, knowledge, and skill of the offeror. By purchasing a Time NFTs you
            acknowledge and agree that you are only purchasing the Time NFT for the services or
            activities underlying the Time NFTs and for no other reason.
          </p>
          <h3>
            <b>Purchases of Time NFTs cannot be revoked or canceled. </b>
          </h3>
          <p>
            Transactions involving Time NFTs, like all blockchain-based transactions, are
            irreversible, final and unable to be refunded or canceled.
            <b>
              {' '}
              A user will not be able to redeem a Time NFT if the digital wallet that they have
              connected to the Site contains insufficient funds to cover the redeeming of the Time
              NFT and the associated gas fees.
            </b>
          </p>
        </li>
        <li>
          <h2>
            <b>5.</b>
            <u>
              <b>Taxes</b>
            </u>
          </h2>
          <h3>
            <b>You are responsible for your taxes and duties. </b>
          </h3>
          <p>
            Users bear sole responsibility for paying any and all sales, use, value-added, and other
            taxes, duties, and assessments now or hereafter claimed or imposed by any governmental
            authority associated with their use of the Services, and/or payable as the result of
            minting, purchase, ownership, sale, transferring, using and/or exploiting of any Time
            NFTs. Blockchain-based transactions, including those involving any type of NFTs, are
            novel and their tax treatment is uncertain
          </p>
          <p>
            You acknowledge and agree that we have no responsibility or liability for or related to
            any Time NFT. Where applicable, it is understood that the offerors of Time NFTs should
            include any VAT liability to the Time NFT price and not try to claim additional payments
            from purchasers.
          </p>
        </li>
        <li>
          <h2>
            <b>6.</b>
            <u>
              <b>Intellectual Property Rights and Ownership</b>
            </u>
          </h2>
          <p>
            Ownership in and to any materials and or deliverables, as well as any intellectual
            property rights to any work product arising from a Time NFT, will be assigned to the
            purchaser upon delivery and the successful expiry of the Time NFT.
          </p>
          <p>
            When redemption of a Time NFT involves an offeror creating custom work (such as artwork,
            design work, written code, report generation, etc.), the delivered work and its
            intellectual property rights shall be the exclusive property of the purchaser and, the
            offeror agrees to, pursuant to these Terms, assign all right, title and interest in and
            to the delivered work to a purchaser.
          </p>
          <p>
            An offeror may indicate in the description of the Time NFT if the rights to the
            underlying work product are provided a) solely for the personal use of the purchaser, or
            b) for personal and commercial purposes of the purchaser. By redeeming a Time NFT, the
            purchaser accepts such conditions as described in the Time NFT.
          </p>
          <h3>
            <b>You understand that you may be liable if you don’t have the necessary rights.</b>
          </h3>
          <p>
            If you do not have the necessary intellectual property or other rights to render the
            services underlying a Time NFT, you may be liable not only to any person whose
            intellectual property or other proprietary rights you violated but also to other users.
            This could happen, for example, if we disable or otherwise remove your access to the
            Services or Site after receiving a valid Digital Millennium Copyright Act (“DMCA”)
            takedown notification without receiving a valid counter-notification (see below). You
            agree to indemnify us for any claims asserted against us arising from you not having the
            necessary rights (see “Indemnification” below) required to use the Site and/or the
            Services.
          </p>
          <p>
            We will not, under any circumstance, be held liable to any user for removing allegedly
            infringing works or otherwise fulfilling our legal obligations under the DMCA. The
            buyer’s sole recourse is against the offeror, not us.
          </p>
          <h3>
            <b>We reserve the right to remove any Time NFT that violates these Terms. </b>
          </h3>
          <p>
            We reserve the right to remove any Time NFT that violates these Terms, including, but
            not limited to, materials that infringe someone else’s copyright, trademark, right of
            publicity, or that constitutes impersonation, unlawful conduct, harassment, or abuse.
          </p>
          <h3>
            <b>
              Report any claims of copyright infringement by contacting our designated DMCA agent.{' '}
            </b>
          </h3>
          <p>
            We handle claims of copyright infringement in accordance with the DMCA. If you believe
            that any Time NFT available on or through the Services has been used in a way that
            violates your copyright, please report this by contacting our designated DMCA agent at:
          </p>
          <p className="flex flex-col">
            <span>Avara UI Labs Ltd. </span>
            <span>Walkers Corporate Limited </span>
            <span>190 Elgin Avenue, George Town</span>
            <span>Grand Cayman KY1-9008, Cayman Islands</span>
            <span>Attn: Legal Department </span>
            <span>Email: IP@avaralabsui.com.</span>
          </p>
          <p>
            Please be sure to include all information required by the DMCA. If you do not, we may
            ignore your takedown request and have no obligation to remove the allegedly infringing
            material. For more information, please see 17 U.S.C. § 512.
          </p>
          <h3>
            <b>Users agree to cooperate with us. </b>
          </h3>
          <p>
            All users expressly agree to cooperate and respond in a timely manner to our
            investigations, requests, and inquiries related to DMCA disputes or allegations of
            infringement.
          </p>
        </li>
        <li>
          <h2>
            <b>7.</b>
            <u>
              <b>The Services</b>
            </u>
          </h2>
          <h3>
            <b>We grant you a license to use our Services.</b>
          </h3>
          <p>
            Contingent upon your ongoing compliance with the Agreement, we grant you a personal,
            worldwide, revocable, non-exclusive and non-assignable license to use the software
            provided to you as part of our Services. The only purpose of this license is to allow
            you to use and enjoy the Services solely as permitted by these Terms.
          </p>
          <h3>
            <b>We own all rights in the Services.</b>
          </h3>
          <p>
            Other than as to user-contributed Time NFTs and the code for the Site and the minting
            contract, both of which are open-sourced, we own any and all right, title, and interest
            in and to the Services including, without limitation, any and all copyrights in and to
            any content, code, data, or other materials that you may access or use on or through the
            Services. Except as expressly set forth herein, your use of or access to the Services
            does not grant you any ownership or other rights therein.
          </p>
          <h3>
            <b>We may use and share your feedback.</b>
          </h3>
          <p>
            Any comments, bug reports, ideas, or other feedback that you may provide about our
            Services, including suggestions about how we might improve our Services, are entirely
            voluntary. You agree that we are free to use or not use any feedback that we receive
            from you as we see fit, including to copy and share such feedback with third parties,
            without any obligation to you.
          </p>
        </li>
        <li>
          <h2>
            <b>8.</b>
            <u>
              <b>Rules and Community Guidelines</b>
            </u>
          </h2>
          <p>
            You may only use the Services — including to mint Time NFTs — if you comply with this
            Agreement (including, without limitation, these Terms), applicable third-party policies,
            and all applicable laws, rules, regulations and related guidance. Newt: Aika maintains a
            friendly, community spirited, and professional environment by which users should abide
            while participating in any use of the Services.
          </p>
          <h3>
            <b>Community contributors are independent. </b>
          </h3>
          <p>
            Contributors to the Newt: Aika community are independent from us, and we will not have
            any liability or responsibility for their actions or omissions.
          </p>
          <h3>
            <b>Community Guidelines</b>
          </h3>
          <p>
            The community is important to us. While we want all community members to be able to
            express themselves, users must use the Services without causing harm to others.
            Accordingly, we prohibit the following conduct:
          </p>
          <ul>
            <li>
              making statements or offering services via Time NFTs that contain personal insults,
              pornography, vulgarity, profanity, obscenity, or other offensive or objectionable
              language or content, or depicting nudity or lewd content of any sort;
            </li>
            <li>
              making statements or offering services via Time NFTs that could reasonably be
              construed as containing hate speech, including the creation of content that is
              intended to harass, abuse, insult, harm, defame, slander, disparage, intimidate,
              threaten or discriminate based on gender, sexual orientation, religion, ethnicity,
              race, age, national origin, or disability;
            </li>
            <li>
              offering Time NFTs that incite violence, encourage violent or dangerous behavior, or
              depict violence (either towards others or yourself); or
            </li>
            <li>
              misrepresenting any service, including by impersonating another individual or entity.
            </li>
          </ul>
          <p>
            We do not endorse and are not responsible for the content of any Time NFT. All other
            users are responsible for themselves while using the Services and for what they
            contribute to the Services.
          </p>
          <h3>
            <b>Other Prohibited Conduct</b>
          </h3>
          <p>The following conduct is also prohibited:</p>
          <ul>
            <li>
              using the Services for, or to promote or facilitate, illegal activity (including,
              without limitation, money laundering, financing terrorism, tax evasion, buying or
              selling illegal drugs, contraband, counterfeit goods, or illegal weapons);
            </li>
            <li>exploiting the Services for any unauthorized commercial purpose;</li>
            <li>
              uploading or transmitting viruses, worms, Trojan horses, time bombs, cancel bots,
              spiders, malware or any other type of malicious code that will or may be used in any
              way that will affect the functionality or operation of the Services;
            </li>
            <li>
              attempting to or actually copying or making unauthorized use of all or any portion of
              the Services, including by attempting to reverse compile, reformatting or framing,
              disassemble, reverse engineer any part of the Services;
            </li>
            <li>
              accessing or using the Services for the purpose of creating a product or service that
              is competitive with the Services;
            </li>
            <li>
              harvesting or otherwise collecting information from the Services for any unauthorized
              purpose;
            </li>
            <li>
              using the Services under false or fraudulent pretenses or otherwise being deceitful;
            </li>
            <li>interfering with other users’ access to or use of the Services;</li>
            <li>
              interfering with or circumventing of the security features of the Services or any
              third party’s systems, networks or resources used in the provision of Services;
            </li>
            <li>
              copying, modifying, or otherwise replicating any of our Services, including, without
              limitation, our smart contracts and/or scripts, except as expressly permitted by a
              separate license authorized by us;
            </li>
            <li>
              engaging in any attack, hack, denial-of-service attack, interference, or exploit of
              any smart contract in connection with use of the Service (and operations performed by
              a user that are technically permitted by a smart contract may nevertheless be a
              violation of our agreement, including these Terms, and the law); or
            </li>
            <li>engaging in any anticompetitive behavior or other misconduct.</li>
          </ul>
          <h3>
            <b>Violating our rules may result in our intervention.</b>
          </h3>
          <p>
            You agree and acknowledge that if you use our Services to engage in conduct prohibited
            by applicable law, permanently reserve the right to completely or partially restrict or
            revoke your access to the Services, either completely or for a period of time, at our
            sole discretion. We reserve the right to amend, rectify, edit, or otherwise alter
            transaction data to remediate or mitigate any damage caused either to us or to any other
            person as a result of a user’s violation of this agreement or applicable law.
          </p>
          <h3>
            <b>You agree to report suspicious activity.</b>
          </h3>
          <p>
            If you observe or suspect a violation of our Terms, please promptly inform us at
            legal@avaralabsui.com.
          </p>
          <h3>
            <b>We reserve the right to investigate violations. </b>
          </h3>
          <p>
            We reserve the right to investigate and prosecute any suspected breaches of this
            Agreement including the Terms. We may disclose any information as necessary to satisfy
            any law, regulation, legal process, or governmental request.
          </p>
        </li>
        <li>
          <h2>
            <b>9.</b>
            <u>
              <b>Disclaimers and Limitations of Liability</b>
            </u>
          </h2>
          <h3>
            <b>We make no representations or warranties. </b>
          </h3>
          <p>
            THE SERVICES ARE PROVIDED ON AN “AS IS” AND “AS AVAILABLE” BASIS. WE AND OUR PARENTS,
            SUBSIDIARIES, AFFILIATES, RELATED COMPANIES, OFFICERS, DIRECTORS, EMPLOYEES, AGENTS,
            REPRESENTATIVES, PARTNERS, AND LICENSORS (COLLECTIVELY, THE “AVARA UI LABS INDEMNIFIED
            PARTIES”) MAKE NO GUARANTEES OF ANY KIND IN CONNECTION WITH THE SERVICES. TO THE MAXIMUM
            EXTENT PERMITTED UNDER APPLICABLE LAW, THE AVARA UI LABS INDEMNIFIED PARTIES DISCLAIM
            ALL WARRANTIES AND CONDITIONS, WHETHER EXPRESS OR IMPLIED, OF MERCHANTABILITY, FITNESS
            FOR A PARTICULAR PURPOSE, OR NON-INFRINGEMENT AND DISCLAIM ALL RESPONSIBILITY AND
            LIABILITY FOR:
          </p>
          <ul>
            <li>
              THE SERVICES BEING ACCURATE, COMPLETE, CURRENT, RELIABLE, UNINTERRUPTED, TIMELY,
              SECURE, OR ERROR-FREE. INFORMATION (INCLUDING, WITHOUT LIMITATION, THE VALUE OF ANY
              TIME NFT) AVAILABLE THROUGH THE SERVICE IS PROVIDED FOR GENERAL INFORMATION ONLY AND
              SHOULD NOT BE RELIED UPON OR USED AS THE SOLE BASIS FOR MAKING DECISIONS. ANY RELIANCE
              ON THE SERVICES IS AT YOUR OWN RISK
            </li>
            <li>
              INJURY OR DAMAGE RESULTING FROM THE SERVICES. FOR EXAMPLE, YOU EXPRESSLY ACKNOWLEDGE,
              UNDERSTAND, AND AGREE THAT THE SERVICES MAY CONTAIN AUDIO-VISUAL EFFECTS, STROBE
              LIGHTS OR OTHER MATERIALS THAT MAY AFFECT YOUR PHYSICAL SENSES AND/OR PHYSICAL
              CONDITION. FURTHER, YOU EXPRESSLY ACKNOWLEDGE THAT THE AVARA UI LABS INDEMNIFIED
              PARTIES ARE NOT RESPONSIBLE FOR LOSS OR DAMAGE CAUSED BY ANOTHER USER’S CONDUCT,
              UNAUTHORIZED ACTORS, OR ANY UNAUTHORIZED ACCESS TO OR USE OF THE SERVICES.
            </li>
            <li>
              VIRUSES, WORMS, TROJAN HORSES, TIME BOMBS, CANCEL BOTS, SPIDERS, MALWARE OR OTHER TYPE
              OF MALICIOUS CODE THAT MAY BE USED IN ANY WAY TO AFFECT THE FUNCTIONALITY OR OPERATION
              OF THE SERVICES.
            </li>
          </ul>
          <h3>
            <b>Limitation of Liability.</b>
          </h3>
          <p>
            TO THE MAXIMUM EXTENT PERMITTED BY LAW, IN NO EVENT SHALL ANY AVARA UI LABS INDEMNIFIED
            PARTY BE LIABLE TO YOU FOR ANY LOSS, DAMAGE, OR INJURY OF ANY KIND INCLUDING ANY DIRECT,
            INDIRECT, SPECIAL, INCIDENTAL, EXEMPLARY, CONSEQUENTIAL, OR PUNITIVE LOSSES OR DAMAGES,
            OR DAMAGES FOR SYSTEM FAILURE OR MALFUNCTION OR LOSS OF PROFITS, DATA, USE, BUSINESS OR
            GOOD-WILL OR OTHER INTANGIBLE LOSSES, ARISING OUT OF OR IN CONNECTION WITH: (A) THE
            SERVICES OR YOUR INABILITY TO USE OR ACCESS THE SERVICES; (B) MISUSE OF THE SERVICES
            (INCLUDING WITHOUT LIMITATION, UNAUTHORIZED ACCESS OF THE SERVICES); (C) ANY USER
            CONDUCT ON THE SERVICES; OR (D) TERMINATION, SUSPENSION OR RESTRICTION OF ACCESS TO ANY
            THE SERVICES.
          </p>
          <p>
            IN ADDITION TO THE FOREGOING, NO AVARA UI LABS INDEMNIFIED PARTY SHALL BE LIABLE FOR ANY
            DAMAGES CAUSED IN WHOLE OR IN PART BY: (A) USER ERROR, SUCH AS FORGOTTEN PASSWORDS OR
            INCORRECTLY CONSTRUCTED SMART CONTRACTS OR OTHER TRANSACTIONS; (B) SERVER FAILURE OR
            DATA LOSS; (C) THE MALFUNCTION, UNEXPECTED FUNCTION OR UNINTENDED FUNCTION OF THE
            BLOCKCHAIN, ANY COMPUTER OR CRYPTOCURRENCY NETWORK (INCLUDING ANY WALLET PROVIDER),
            INCLUDING WITHOUT LIMITATION LOSSES ASSOCIATED WITH NETWORK FORKS, REPLAY ATTACKS,
            DOUBLE-SPEND ATTACKS, SYBIL ATTACKS, 51% ATTACKS, GOVERNANCE DISPUTES, MINING
            DIFFICULTY, CHANGES IN CRYPTOGRAPHY OR CONSENSUS RULES, HACKING, OR CYBERSECURITY
            BREACHES; (D) ANY CHANGE IN VALUE OF ANY CRYPTOCURRENCY; (E) ANY CHANGE IN LAW,
            REGULATION, OR POLICY; (VI) EVENTS OF FORCE MAJEURE; OR (F) ANY THIRD PARTY.
          </p>
          <p>
            THIS LIMITATION OF LIABILITY IS INTENDED TO APPLY WITHOUT REGARD TO WHETHER OTHER
            PROVISIONS OF THESE TERMS HAVE BEEN BREACHED OR HAVE PROVEN INEFFECTIVE. THE LIMITATIONS
            SET FORTH IN THIS SECTION SHALL APPLY REGARDLESS OF THE FORM OF ACTION, WHETHER THE
            ASSERTED LIABILITY OR DAMAGES ARE BASED ON CONTRACT, INDEMNIFICATION, TORT, STRICT
            LIABILITY, STATUTE, OR ANY OTHER LEGAL OR EQUITABLE THEORY, AND WHETHER OR NOT THE AVARA
            UI LABS INDEMNIFIED PARTIES HAVE BEEN INFORMED OF THE POSSIBILITY OF ANY SUCH DAMAGE
          </p>
          <p>
            IN NO EVENT WILL THE AVARA UI LABS INDEMNIFIED PARTIES’ CUMULATIVE LIABILITY TO YOU OR
            ANY OTHER USER, FROM ALL CAUSES OF ACTION AND ALL THEORIES OF LIABILITY EXCEED ONE
            THOUSAND U.S. DOLLARS (U.S. $1,000.00).
          </p>
          <p>
            UNDER NO CIRCUMSTANCES SHALL ANY AVARA UI LABS INDEMNIFIED PARTY BE REQUIRED TO DELIVER
            TO YOU ANY VIRTUAL CURRENCY AS DAMAGES, MAKE SPECIFIC PERFORMANCE, OR ANY OTHER REMEDY.
            IF YOU WOULD BASE YOUR CALCULATIONS OF DAMAGES IN ANY WAY ON THE VALUE OF VIRTUAL
            CURRENCY, YOU AND WE AGREE THAT THE CALCULATION SHALL BE BASED ON THE LOWEST VALUE OF
            THE VIRTUAL CURRENCY DURING THE PERIOD BETWEEN THE ACCRUAL OF THE CLAIM AND THE AWARD OF
            DAMAGES.
          </p>
          <p>
            Some jurisdictions do not allow the exclusion or limitation of certain warranties and
            liabilities provided in this section; accordingly, some of the above limitations and
            disclaimers may not apply to you. To the extent applicable law does not permit Avara UI
            Labs Indemnified Parties to disclaim certain warranties or limit certain liabilities,
            the extent of Avara UI Labs Indemnified Parties’ liability and the scope of any such
            warranties will be as permitted under applicable law
          </p>
        </li>
        <li>
          <h2>
            <b>10.</b>
            <u>
              <b>Indemnification</b>
            </u>
          </h2>
          <p>
            You agree to indemnify, defend, and hold harmless the Avara UI Labs Indemnified Parties
            from any claim or demand, including reasonable attorneys’ fees, made by any third party
            due to or arising out of: (a) your breach or alleged breach of the agreement (including,
            without limitation, these Terms); (b) anything you contribute to the Services, including
            Time NFTs; (c) your misuse of the Services, any Time NFT (or any service associated
            therewith), or any smart contract and/or script related thereto; (d) your violation of
            any laws, rules, regulations, codes, statutes, ordinances, or orders of any governmental
            or quasi-governmental authorities; (e) your violation of the rights of any third party,
            including any intellectual property right, publicity, confidentiality, property, or
            privacy right; (f) your use of a third-party product, service, and/or website; or (g)
            any misrepresentation made by you. We reserve the right to assume, at your expense, the
            exclusive defense and control of any matter subject to indemnification by you. You agree
            to cooperate with our defense of any claim. You will not in any event settle any claim
            without our prior written consent.
          </p>
        </li>
        <li>
          <h2>
            <b>11.</b>
            <u>
              <b>Assumption of the Risk</b>
            </u>
          </h2>
          <h3>
            <b>
              We are a non-custodial Site, which means we do not custody any Time NFTs, or funds or
              provide escrow services.{' '}
            </b>
          </h3>
          <p>
            It is important to understand that transactions using the Services occur directly
            between or among users; we are not a party to the transaction; we do not have
            possession, custody or control over the Time NFTs appearing on the Services; and we do
            not have possession, custody, or control over any user’s funds. Further, we do not
            store, send, or receive any Time NFTs.
          </p>
          <h3>
            <b>Transactions on the blockchain are not anonymous.</b>
          </h3>
          <p>
            A widespread belief is that transactions involving blockchains (including NFTs) are
            anonymous. In fact, a central feature of blockchains and thus, blockchain-based
            transactions are that they are transparent. Your public key and your wallet address,
            which you need to buy or sell items on the blockchain, are visible to anyone. To the
            extent your public key or wallet address can be linked back to you, it would be possible
            for someone to determine your identity and know or Time NFTs you own.
          </p>
          <h3>
            <b>
              You assume the risks of engaging in transactions that rely on smart contracts and
              other experimental technology.
            </b>
          </h3>
          <p>
            Transactions enabled by the Services, including minting, buying, and selling Time NFTs,
            rely on smart contracts stored on the Polygon blockchain, cryptographic tokens generated
            by the smart contracts, and other nascent software and applications. These technologies
            are experimental, speculative, inherently risky, and subject to change. Among other
            risks, bugs, malfunctions, cyberattacks, or changes to the Polygon blockchain (e.g.,
            forks) could disrupt these technologies and even result in a total loss of NFTs, their
            market value, or digital funds. You are solely responsible for the safekeeping of the
            private key associated with the blockchain address used to interact with the Services.
            We assume no liability or responsibility for any such risks. If you are not comfortable
            assuming these risks, you should not access or engage in transactions using the
            Services.
          </p>
          <p>
            One of the other defining features of blockchain technology is that its entries are
            immutable, which means, as a technical matter, they generally cannot be deleted or
            modified by anyone. This includes smart contracts and Time NFT generated and programmed
            by smart contracts. THUS, TRANSACTIONS RECORDED ON THE BLOCKCHAIN, INCLUDING TRANSFERS
            OF TIME NFTS AND DATA PROGRAMMED INTO TIME NFTS (SUCH AS REVENUE AND INTEREST
            ALLOCATIONS), MUST BE TREATED AS PERMANENT AND CANNOT BE UNDONE BY US OR BY ANYONE. YOU
            MUST BE VERY CAREFUL WHEN YOU FINALIZE ANY TRANSACTION THAT WILL BE RECORDED ON THE
            BLOCKCHAIN.
          </p>
          <h3>
            <b>We are not liable for any third-party services.</b>
          </h3>
          <p>
            We are not responsible for the content or services of any third party, including,
            without limitation, any network, or apps like Discord, or MetaMask, and we make no
            representations regarding the content or accuracy of any third party services or
            materials. The use and access of any third-party products or services, including through
            the Services, is at your own risk.
          </p>
          <h3>
            <b>
              You agree to the automated collection and disbursement of proceeds by smart contracts.
            </b>
          </h3>
          <p>
            You acknowledge and agree that all transactions accessed through the Services will be
            automatically processed using one or more blockchain-based smart contracts. By engaging
            in transactions using the Services, you acknowledge and consent to the automatic
            processing of all transactions, including for the purchase and sale of Time NFTs using
            the Services. You further acknowledge and agree that the applicable smart contract will
            dictate how the funds of a transaction and ownership of a Time NFT are distributed.
          </p>
          <h3>
            <b>You acknowledge the risks of using the Services.</b>
          </h3>
          <p>
            You bear sole responsibility for evaluating the Services before using them, and all
            transactions accessed through the Services are irreversible, final, and without refunds.
            The Services may be disabled, disrupted or adversely impacted as a result of
            sophisticated cyber-attacks, surges in activity, computer viruses, and/or other
            operational or technical challenges, among other things. We disclaim any ongoing
            obligation to notify you of all of the potential risks of using and accessing our
            Services. You agree to accept these risks and agree that you will not seek to hold any
            Avara UI Labs Indemnified Party responsible for any consequent losses.
          </p>
          <h3>
            <b>You are solely responsible for the security of your wallet</b>
          </h3>
          <p>
            You understand and agree that you are solely responsible for maintaining the security of
            your wallet. Any unauthorized access to your wallet by third parties could result in the
            loss or theft of any Time NFT, or any funds held in your account and any associated
            accounts. You understand and agree that we have no involvement in, and you will not hold
            us responsible for managing and maintaining the security of your wallet. You further
            understand and agree that we are not responsible, and you will not hold us responsible,
            for any unauthorized access to your wallet. It is your responsibility to monitor your
            wallet. If you notice any unauthorized or suspicious activity in your wallet in
            connection with your use of the Services, please notify us immediately.
          </p>
          <h3>
            <b>We reserve the right to block your wallet from engaging with the Services.</b>
          </h3>
          <p>
            You agree that we have the right to immediately block your wallet and restrict your
            access to the Services if we suspect, in our sole discretion, that (a) your account is
            being used for money laundering or any illegal activity; (b) you have engaged in
            fraudulent activity; (c) you have acquired Time NFT using inappropriate methods,
            including the use of stolen funds to purchase Time NFTs; (d) you are the target of any
            sanctions administered or enforced by the U.S. Department of the Treasury’s Office of
            Foreign Assets Control (“OFAC”), the United Nations Security Council, the European
            Union, Her Majesty’s Treasury, or any other legal or regulatory authority in any
            applicable jurisdiction; (e) either you, as an individual or an entity, or your wallet
            address is listed on the Specially Designated Nationals and Blocked Persons List (“SDN
            List”), Consolidated Sanctions List (“Non-SDN Lists), or any other sanctions lists
            administered by OFAC; (f) you are located, organized, or resident in a country or
            territory that is, or whose government is, the subject of sanctions, including Côte
            d’Ivoire, Cuba, Belarus, Iran, Iraq, Liberia, North Korea, Sudan, and Syria; or (g) you
            have otherwise acted in violation of these Terms.
          </p>
          <p>
            If we have a reasonable suspicion that you are utilizing the Site for illegal purposes,
            we reserve the right to take whatever action we deem appropriate, including but not
            limited to blocking your wallet.
          </p>
        </li>
        <li>
          <h2>
            <b>12.</b>
            <u>
              <b>Arbitration Agreement and Waiver of Rights, Including Class Actions.</b>
            </u>
          </h2>
          <p>
            PLEASE READ THIS SECTION CAREFULLY: IT MAY SIGNIFICANTLY AFFECT YOUR LEGAL RIGHTS,
            INCLUDING YOUR RIGHT TO FILE A LAWSUIT IN COURT AND TO HAVE A JURY HEAR YOUR CLAIMS. IT
            CONTAINS PROCEDURES FOR MANDATORY BINDING ARBITRATION AND A CLASS ACTION WAIVER.
          </p>
          <h3>
            <u>Agreement to Attempt to Resolve Disputes Through Good Faith Negotiations</u>
          </h3>
          <p>
            Prior to commencing any legal proceeding against us of any kind, including an
            arbitration as set forth below, you and we agree that we will attempt to resolve any
            dispute, claim, or controversy between us arising out of or relating to the agreement or
            the Services (each, a “Dispute” and, collectively, “Disputes”) by engaging in good faith
            negotiations. Such good faith negotiations require, at a minimum, that the aggrieved
            party provide a written notice to the other party specifying the nature and details of
            the Dispute. The party receiving such notice shall have thirty (30) days to respond to
            the notice. Within sixty (60) days after the aggrieved party sent the initial notice,
            the parties shall meet and confer in good faith by videoconference, or by telephone, to
            try to resolve the Dispute. If the parties are unable to resolve the Dispute within
            ninety (90) days after the aggrieved party sent the initial notice, the parties may
            agree to mediate their Dispute, or either party may submit the Dispute to arbitration as
            set forth below.
          </p>
          <h3>
            <u>Agreement to Arbitrate</u>
          </h3>
          <p>
            You and we agree that any Dispute that cannot be resolved through the procedures set
            forth above will be resolved through binding arbitration in accordance with the
            International Arbitration Rules of the International Centre for Dispute Resolution. The
            place of arbitration shall be the Cayman Islands. The language of the arbitration shall
            be English. The arbitrator(s) shall have experience adjudicating matters involving
            Internet technology, software applications, financial transactions and, ideally,
            blockchain technology. The arbitrator’s award of damages must be consistent with the
            terms of the “Limitation of Liability” subsection of these Terms as to the types and
            amounts of damages for which a party may be held liable. The prevailing party will be
            entitled to an award of their reasonable attorney’s fees and costs. Except as may be
            required by law, neither a party nor its representatives may disclose the existence,
            content, or results of any arbitration hereunder without the prior written consent of
            (all/both) parties.
          </p>
          <p>
            UNLESS YOU TIMELY PROVIDE US WITH AN ARBITRATION OPT-OUT NOTICE (AS DEFINED BELOW IN THE
            SUBSECTION TITLED “YOUR CHOICES”), YOU ACKNOWLEDGE AND AGREE THAT YOU AND WE ARE EACH
            WAIVING THE RIGHT TO A TRIAL BY JURY OR TO PARTICIPATE AS A PLAINTIFF OR CLASS MEMBER IN
            ANY PURPORTED CLASS ACTION OR REPRESENTATIVE PROCEEDING. FURTHER, UNLESS BOTH YOU AND WE
            OTHERWISE AGREE IN WRITING, THE ARBITRATOR MAY NOT CONSOLIDATE MORE THAN ONE PERSON’S
            CLAIMS AND MAY NOT OTHERWISE PRESIDE OVER ANY FORM OF ANY CLASS OR REPRESENTATIVE
            PROCEEDING.
          </p>
          <h3>
            <u>Changes </u>
          </h3>
          <p>
            By rejecting any changes to these Terms, you agree that you will arbitrate any Dispute
            between you and us in accordance with the provisions of this section as of the date you
            first accepted these Terms (or accepted any subsequent changes to these Terms).
          </p>
        </li>
        <li>
          <h2>
            <b>13.</b>
            <u>
              <b>Waiver of Injunctive or Other Equitable Relief</b>
            </u>
          </h2>
          <p>
            TO THE MAXIMUM EXTENT PERMITTED BY LAW, YOU AGREE THAT YOU WILL NOT BE PERMITTED TO
            OBTAIN AN INJUNCTION OR OTHER EQUITABLE RELIEF OF ANY KIND, SUCH AS ANY COURT OR OTHER
            ACTION THAT MAY INTERFERE WITH OR PREVENT THE DEVELOPMENT OR EXPLOITATION OF THE
            SERVICES, OR ANY OTHER WEBSITE, APPLICATION, CONTENT, SUBMISSION, PRODUCT, SERVICE, OR
            INTELLECTUAL PROPERTY OWNED, LICENSED, USED OR CONTROLLED BY ANY AVARA UI LABS
            INDEMNIFIED PARTY.
          </p>
        </li>
        <li>
          <h2>
            <b>14.</b>
            <u>
              <b>Termination; Cancellation</b>
            </u>
          </h2>
          <p>
            This Agreement is effective unless and until terminated by either you or us. You may
            terminate your Agreement with us at any time by not accessing the Site or the Services.
            If, in our sole judgment, you fail, or we suspect that you have failed, to comply with
            any term or provision of the Agreement (including without limitation any provision of
            these Terms), we reserve the right to terminate our Agreement with you and deny you
            access to the Services. We further reserve the right to restrict your access to the Site
            by blocking your wallet or to stop providing you with all or a part of the Services at
            any time and for no reason, including, without limitation, if we reasonably believe: (a)
            your use of the Services exposes us to risk or liability; (b) you are using the Services
            for unlawful purposes; or (c) it is not commercially viable to continue providing you
            with our Services. All of these are in addition to any other rights and remedies that
            may be available to us, whether in equity or at law, all of which we expressly reserve.
          </p>
          <p>
            WE RESERVE THE RIGHT TO MODIFY THE SERVICES AT ANY TIME, BUT WE HAVE NO OBLIGATION TO
            UPDATE THE SERVICES. YOU AGREE THAT IT IS YOUR RESPONSIBILITY TO MONITOR CHANGES TO THE
            SERVICES THAT MAY AFFECT YOU. YOU AGREE THAT WE MAY REMOVE THE SERVICES AND/OR ANY
            CONTENT THEREON FOR INDEFINITE PERIODS OF TIME OR CANCEL THE SERVICES AT ANY TIME,
            WITHOUT NOTICE TO YOU.
          </p>
        </li>
        <li>
          <h2>
            <b>15.</b>
            <u>
              <b>Severability</b>
            </u>
          </h2>
          <p>
            If any provision of the Agreement (including, without limitation, these Terms) is
            determined to be unlawful, void, or unenforceable, such provision shall nonetheless be
            enforceable to the fullest extent permitted by applicable law, and the unenforceable
            portion shall be deemed to be severed from the Agreement. Such determination shall not
            affect the validity and enforceability of any other remaining provisions.
          </p>
        </li>
        <li>
          <h2>
            <b>16.</b>
            <u>
              <b>Assignment</b>
            </u>
          </h2>
          <p>
            The Agreement (including, without limitation, these Terms) may be assigned without your
            prior consent to any Avara UI Labs Indemnified Party, or to its successors in the
            interest of any business associated with the Services provided by us. You may not assign
            or transfer any rights or obligations under the Agreement without our prior written
            consent.
          </p>
        </li>
        <li>
          <h2>
            <b>17.</b>
            <u>
              <b>California Residents</b>
            </u>
          </h2>
          <p>
            Residents of California are entitled to the following specific consumer rights
            information: you may contact the Complaint Assistance Unit of the Division of Consumer
            Services of the Department of Consumer Affairs by mail at: 1625 North Market Blvd.,
            Suite N 112, Sacramento, California, 95834 or by telephone at (916) 445-1254. Their
            website is located at: http://www.dca.ca.gov.
          </p>
        </li>
        <li>
          <h2>
            <b>18.</b>
            <u>
              <b>Entire Agreement</b>
            </u>
          </h2>
          <p>
            The Agreement (including, without limitation, these Terms, and the Avara UI Labs Privacy
            Policy) and any policies or operating rules posted by us on the Services constitute the
            entire agreement and understanding between you and us and govern your use of the
            Services, superseding any prior or contemporaneous agreements, communications, and
            proposals, whether oral or written, between you and us (including, but not limited to,
            any prior versions of these Terms). Any failure by us to exercise or enforce any right
            or provision of the Agreement (including, without limitation, these Terms) shall not
            constitute a waiver of such right or provision.
          </p>
        </li>
      </ol>
    </main>
  );
}
